import { render, staticRenderFns } from "./Backstage.vue?vue&type=template&id=2b4e3c90&scoped=true"
import script from "./Backstage.vue?vue&type=script&lang=ts"
export * from "./Backstage.vue?vue&type=script&lang=ts"
import style0 from "./Backstage.vue?vue&type=style&index=0&id=2b4e3c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e3c90",
  null
  
)

export default component.exports